import { requestFactory } from './index';
const marketingRequest = requestFactory('/api/marketing');
const menuRequest = requestFactory('/api/menu');
export function getDiscountTerms(productInfo, chargeType, billingItemUid) {
    return marketingRequest({
        method: 'get',
        url: '/discount/productPeriodDiscount',
        params: {
            ...productInfo,
            payType: chargeType === 'POSTPAID' ? 'POSTPAID' : 'PREPAYMENT',
            billingItemUid,
        },
    });
}
/**
 * 获取是否同意过该协议
 */
export function getTermAgree(params) {
    return menuRequest({
        method: 'get',
        url: '/terms/agree',
        params,
    });
}
/**
 * 同意过该协议
 */
export function sendTermAgree(data) {
    return menuRequest({
        method: 'post',
        url: '/terms/agree',
        data,
    });
}
